import SelfStorageHero from 'assets/images/psp/SelfStorage/what-is-self-storage-hero.png';

import storage5x5 from 'assets/images/psp/SelfStorage/sizetable/sizetable-5x5.png';
import storage5x10 from 'assets/images/psp/SelfStorage/sizetable/sizetable-5x10.png';
import storage5x15 from 'assets/images/psp/SelfStorage/sizetable/sizetable-5x15.png';
import storage10x10 from 'assets/images/psp/SelfStorage/sizetable/sizetable-10x10.png';
import storage10x15 from 'assets/images/psp/SelfStorage/sizetable/sizetable-10x15.png';
import storage10x20 from 'assets/images/psp/SelfStorage/sizetable/sizetable-10x20.png';
import storage10x30 from 'assets/images/psp/SelfStorage/sizetable/sizetable-10x30.png';

import SelfStorage1 from 'assets/images/psp/SelfStorage/indoor-climate-controlled-storage-units.webp';
import SelfStorage2 from 'assets/images/psp/SelfStorage/shutterstock_2390631209-scaled.jpg';
import SelfStorage3 from 'assets/images/psp/SelfStorage/shutterstock_2575870815-scaled.jpg';
import SelfStorage4 from 'assets/images/psp/SelfStorage/shutterstock_694770004-scaled.jpg';
import { storageCategories } from '../utils/getPSPLinks';

const heroContent = {
	title: 'What Is Self Storage and How Does It Work?',
	description:
		'Running out of space at home? Self storage can solve everyday storage challenges without breaking the bank. At **SelfStorage.com**, we make it easy to find affordable, reliable storage units with the right features—whether you need drive-up access, climate control, or 24-hour access. Compare units in your area and reserve with confidence, all in one place.',
	image: SelfStorageHero,
	storageType: 'Self Storage',
	CTAtext: 'Find Self Storage',
};

const sizeGuideContent = [
	{
		type: 'cardStrip',
		props: {
			heading: 'Self Storage Unit Size Guide',
			cardData: [
				{
					title: '5x5',
					size: '25 sq ft',
					content:
						'**Looks Like:** Half closet\n\n**What Can Fit:** Small items such as bags, suitcases, and boxes\n\n**Average Monthly Cost:** $35.27\n\n',
					imageSrc: storage5x5,
					contentAlign: 'text-left',
				},
				{
					title: '5x10',
					size: '50 sq ft',
					content:
						'**Looks Like:** Large walk-in closet\n\n**What Can Fit:** The contents of an average studio apartment\n\n**Average Monthly Cost:** $51.47\n\n',
					imageSrc: storage5x10,
					contentAlign: 'text-left',
				},
				{
					title: '5x15',
					size: '75 sq ft',
					content:
						'**Looks Like:** Small bedroom\n\n**What Can Fit:** The contents of a small one-bedroom apartment\n\n**Average Monthly Cost:** $67.73\n\n',
					imageSrc: storage5x15,
					contentAlign: 'text-left',
				},
				{
					title: '10x10',
					size: '100 sq ft',
					content:
						'**Looks Like:** Average bedroom\n\n**What Can Fit:** The contents of a one-bedroom apartment\n\n**Average Monthly Cost:** $82.81\n\n',
					imageSrc: storage10x10,
					contentAlign: 'text-left',
				},
				{
					title: '10x15',
					size: '150 sq ft',
					content:
						'**Looks Like:** Small one-car garage\n\n**What Can Fit:** The contents of a two-bedroom house or large apartment\n\n**Average Monthly Cost:** $109.48\n\n',
					imageSrc: storage10x15,
					contentAlign: 'text-left',
				},
				{
					title: '10x20',
					size: '200 sq ft',
					content:
						'**Looks Like:** Standard one-car garage\n\n**What Can Fit:** The contents of a two- to three-bedroom house or a  full garage\n\n**Average Monthly Cost:** $132.43\n\n',
					imageSrc: storage10x20,
					contentAlign: 'text-left',
				},
				{
					title: '10x30',
					size: '300 sq ft',
					content:
						'**Looks Like:** Two-car garage\n\n**What Can Fit:** Four- to five-bedroom house with appliances or a 40-ft. moving van\n\n**Average Monthly Cost:** $165.85\n\n',
					imageSrc: storage10x30,
					contentAlign: 'text-left',
				},
			],
		},
	},
];

const videoContent = {
	title: 'SS Video section',
	background: 'blueGradient',
	modules: [
		{
			type: 'video',
			props: {
				content: {
					title: 'Self Storage Features that Matter',
					description:
						"Before you choose a self storage unit, it's worth knowing which features align with your needs.",
					videoSrc: 'https://youtube.com/embed/i4ePmg4rTn8',
					suffixText:
						'Climate control helps protect furniture, electronics, and vehicles from environmental damage in the long run; 24/7 access storage allows flexibility to retrieve your items on your schedule; and drive-up access makes it easier to load and unload bulky items.\n\nWith **SelfStorage.com**, you can filter facilities by amenities to find the right fit.',
				},
			},
		},
	],
};

const sizeChartContent = [
	{
		type: 'cardStrip',
		props: {
			heading: 'What Can You Store in a Self Storage Unit?',
			description:
				'Self storage is a game-changer for anyone looking to downsize, declutter, or simply preserve belongings during big life events - but not everything can go into your self storage unit. Here’s a quick list to keep you and your stuff safe in storage.',
			removeMinHeight: true,
			cardData: [
				{
					title: 'Items you can store',
					content:
						'- Furniture\n- Household goods (artwork, books, home decor, etc.)\n- Sports equipment\n- Commercial goods\n- Electronics\n- Appliances\n- Cars, boats, motorcycles, and RVs\n- Alcohol',
					contentAlign: 'text-left',
				},
				{
					title: 'Items you cannot store',
					content:
						'- Money\n- Firearms, ammunition, or weapons caches\n- Live animals or plants\n- Stolen property\n- Hazardous materials\n- Noxious materials\n- Flammable materials\n- Perishable items, like food\n- Illegal drugs\n- Unregistered or uninsured vehicles and tires\n- Furs\n- Wet items\n- Living creatures (humans, animals, plants, etc.)',
					contentAlign: 'text-left',
				},
			],
		},
	},
];

const reviewsContent = {
	headerTitle: 'Self Storage: ',
	reviews: [
		{
			title: 'Booking a storage building online...',
			stars: 5,
			text: "Booking a storage building online couldn't have been any easier.",
			customerName: 'Floyd Dixon',
			date: 'May 15, 2024',
			link: 'https://www.trustpilot.com/reviews/682a0361abc2d7327f29c41c',
		},
		{
			title: 'Made it so easy!',
			stars: 5,
			text: 'It was phenomenal not to have to call around and check rates. I could simply look through their list of available units and their prices. In just a few clicks, I had reserved one and got a confirmation email from the storage facility. Super easy.',
			customerName: 'Chelsea B',
			date: 'March 22, 2024',
			link: 'https://www.trustpilot.com/reviews/6829f1bc8b720324a1e15c84',
		},
		{
			title: 'I had a fantastic experience with SelfStorage...',
			stars: 5,
			text: 'I had a fantastic experience with SelfStorage. From the start, the staff was welcoming, professional, and made the whole process smooth and stress-free. The facility itself was spotless, secure, and easy to access—which really stood out to me. If you need a clean, reliable, and well-managed storage option, SelfStorage is definitely the way to go. Highly recommended!',
			customerName: 'Daylon Coleman',
			date: 'October 8, 2024',
			link: 'https://www.trustpilot.com/reviews/6828c99fab7da691109e37ea',
		},
		{
			title: 'Concise and harmonious.',
			stars: 5,
			text: 'SelfStorage.com search feature streamlined finding the right unit(s). Immediate follow-up text upon reservation. The reservation process was simple and easy, and nothing was charged up front.',
			customerName: 'Corbin Robinson',
			date: 'November 2, 2024',
			link: 'https://www.trustpilot.com/reviews/68262fe9ce693ab3495bd8b7',
		},
	],
};

const faqSectionContent = {
	header: 'Self Storage FAQs',
	faqs: [
		{
			question: 'What insurance do I need for a storage unit?',
			answer: "You need a dedicated [storage unit insurance policy](https://www.selfstorage.com/blog/self-storage-insurance-coverage/), a tenant protection plan from your facility, or coverage through your existing renters/homeowners insurance extension. The right choice depends on what you're storing, the value of items, and whether your current insurance extends to off-premises storage.",
		},
		{
			question:
				"What's the average cost of storage unit insurance vs. tenant protection plans?",
			answer: "Storage protection costs $8-$38 monthly for $10,000 coverage, depending on the provider. This is relatively affordable compared to standard renters/homeowners policies. Remember, you're only insuring stored items, not everything you own. Renters' insurance averages $13 monthly for $20,000 property coverage nationwide.",
		},
		{
			question: 'Do storage facilities offer insurance for purchase?',
			answer: 'Most self storage facilities offer insurance, though policies and coverage limits vary. Some provide protection plans covering damage, while others offer insurance for loss/theft. Your choice depends on specific needs and budget.',
		},
		{
			question: 'Can I access my storage unit outside of business hours?',
			answer: "Many facilities offer 24/7 access, giving you the flexibility to visit your self storage unit at your convenience. Use **SelfStorage.com's** search tool to find units with 24/7 access, and check with your chosen location to confirm their specific access hours and policies.",
		},
		{
			question: 'Is long-term storage cheaper?',
			answer: 'Yes, long-term storage often comes with discounted rates or special offers. Depending on your needs, committing to a longer lease can reduce monthly cost compared to short-term rentals. To learn more about whether short-term or long-term storage is better for you, [check out this blog](https://www.selfstorage.com/blog/long-term-vs-short-term-storage-guide/).',
		},
		{
			question: 'Are storage units suitable for a workshop?',
			answer: "Some storage units can be used as a workshop, especially [those with electricity](https://www.selfstorage.com/blog/storage-units-with-electricity/) and proper lighting. However, usage policies may vary, so it's important to check with the facility directly for any rules and restrictions.",
		},
		{
			question: 'How should I prepare my vehicle for long-term storage?',
			answer: 'Clean your vehicle thoroughly, change the oil and fluids if needed, inflate tires to the correct pressure, disconnect the battery, and cover the vehicle with a breathable cover. These steps help prevent damage during storage. If you are storing vehicles in colder areas, properly winterizing your vehicles is especially important. For more details, explore our winter storage guides for cars, boats, RVs, and motorcycles.',
		},
	],
};

const relatedContent = {
	heading: 'Learn All About Self Storage Units',
	type: 'unitCards',
	id: 'self-storage-related-content',
	data: {
		slug: 'self-storage-related-content',
		unitCards: [
			{
				title: 'Storage Tips',
				url: 'https://www.selfstorage.com/blog/what-is-climate-controlled-storage-2/',
				layout: false,
				plain: true,
				date: 'January 15, 2025',
				image: SelfStorage1,
				content:
					'Why Would You Need a Climate-Controlled Storage Unit?',
			},
			{
				title: 'Storage Tips',
				url: 'https://www.selfstorage.com/blog/24-hour-storage-amenities/',
				layout: false,
				plain: true,
				date: 'February 10, 2025',
				image: SelfStorage2,
				content:
					'24/7 Storage: What Amenities are Worth Your Time and Money?',
			},
			{
				title: 'Storage Tips',
				url: 'https://www.selfstorage.com/blog/self-storage-insurance-coverage/',
				layout: false,
				plain: true,
				date: 'March 5, 2025',
				image: SelfStorage3,
				content:
					'Storage Unit Insurance: What You Need To Know Before Renting',
			},
			{
				title: 'Storage Tips',
				url: 'https://www.selfstorage.com/blog/best-locks-for-self-storage-units/',
				layout: false,
				plain: true,
				date: 'April 20, 2025',
				image: SelfStorage4,
				content: 'Choosing the Best Locks For Storage Units',
			},
		],
	},
};

const moreWaysToStoreContent = [
	{
		type: 'links',
		props: {
			heading: {
				headingName: 'More ways to store',
			},
			type: 'unitCards',
			id: 'storage size unit cards',
			linksList: storageCategories.selfStorage,
		},
	},
];

export const SelfStorageContent = {
	type: 'self',
	reviews: reviewsContent.reviews,
	sections: [
		{
			title: 'Self Storage Hero',
			background: 'default',
			modules: [
				{
					type: 'hero',
					id: 'self-storage-hero',
					props: {
						content: heroContent,
						additionalProps: {
							heading: {
								size: 'large',
								color: 'white',
								weight: 'ultraBold',
							},
						},
					},
				},
			],
		},
		{
			title: 'Self-Storage Size Guide',
			modules: sizeGuideContent,
		},
		videoContent,
		{
			title: 'Self-Storage Size Chrt',
			modules: sizeChartContent,
		},
		{
			title: 'Reviews Section',
			background: 'lighterBlue',
			modules: [
				{
					type: 'reviews',
					title: 'Reviews Section',
					slug: 'self-storage-reviews',
					props: {
						reviewsData: reviewsContent,
					},
				},
			],
		},
		{
			title: 'Faqs Section',
			modules: [
				{
					type: 'faqs',
					props: {
						content: faqSectionContent,
					},
				},
			],
		},
		{
			title: 'Related Content',
			background: 'darkBlue',
			modules: [
				{
					type: 'featuredContent',
					props: {
						data: relatedContent,
					},
				},
			],
		},
		{
			title: 'Link to other PSPs',
			background: 'lighterBlue',
			modules: moreWaysToStoreContent,
		},
		{
			background: 'gray',
			modules: [
				{
					type: 'storageNearYou',
				},
			],
		},
	],
};
